module.exports = __webpack_public_path__ + "static/media/tlyfe-video-mock.e60dd326.png";